import Constants from './Constants';

let levelCount = 0;

/* Class responsible for pulling content from the json and loading into containers for the client to consume. */
class CurriculumManager {
  constructor() {
    // the container for all content based on the level
    this.allContentByLevel = [];
  }

  setCurriculum(curriculum) {
    this.curriculum = curriculum;

    curriculum
      .lessons[0]
      .activitySets[0]
      .sentenceOrganizationActivitySets
      .forEach((element) => {
        levelCount = Math.max(levelCount, element.level);
      });

    this.allContentByLevel = [];

    this.addContentToContainers();
  }

  loadRoundContent(level, side) {
    return this.allContentByLevel[level][side];
  }

  // Load the current onboarding content.
  loadOnboardingContent() {
    return this.allContentByLevel[0][0];
  }

  // Load in all content from the json file into the allContentByLevel container
  addContentToContainers() {
    this.curriculum.lessons[0].activitySets[0].sentenceOrganizationActivitySets.forEach((item) => {
      const currentItem = item;
      if (currentItem.contentType === Constants.CONTENT_TYPES.CAUSEEFFECT) {
        currentItem.headerOne = Constants.CONTENT_HEADERS.CAUSE;
        currentItem.headerTwo = Constants.CONTENT_HEADERS.EFFECT;
      } else if (currentItem.contentType === Constants.CONTENT_TYPES.PROBLEMSOLUTION) {
        currentItem.headerOne = Constants.CONTENT_HEADERS.PROBLEM;
        currentItem.headerTwo = Constants.CONTENT_HEADERS.SOLUTION;
      }

      if (currentItem.level !== null) {
        if (!this.allContentByLevel[currentItem.level]) {
          this.allContentByLevel[currentItem.level] = [[], []];
        }
        this.allContentByLevel[currentItem.level][currentItem.side].push(currentItem);
      }
    });
  }
}

export default CurriculumManager;

const manager = new CurriculumManager();

export const curriculumManager = manager;

export const getLevelCount = () => levelCount;
